import { isEmpty } from 'lodash';

export const getProfilePermissions = ({ data, included, modularityPermissions }) => {
  const {
    relationships: {
      permissions: { data: userPermissionData },
    },
  } = data[0];

  const corePermissions = userPermissionData.reduce((acc, item) => {
    const permissionObj = included.find(({ type, id }) => item.type === type && item.id === id);
    return isEmpty(permissionObj) ? acc : acc.concat(permissionObj?.attributes?.codename);
  }, []);

  const detailedPermissions = userPermissionData.reduce((acc, item) => {
    const permissionObj = included.find(({ type, id }) => item.type === type && item.id === id);
    return isEmpty(permissionObj)
      ? acc
      : acc.concat({ codename: permissionObj?.attributes?.codename, name: permissionObj?.attributes?.name });
  }, []);

  const permissions = corePermissions.concat(modularityPermissions);

  return {
    permissions,
    detailedPermissions,
  };
};
